import { NgModule } from '@angular/core';
import { DialogComponent } from './dialog/dialog.component';
import { DialogTitleBarComponent } from './dialog/dialog-titlebar.component';
import { DialogService } from './dialog/dialog.service';
import { DialogContainerDirective } from './dialog/dialog-container.directive';
import { DialogContainerService } from './dialog/dialog-container.service';
import { SharedModule, SHARED_DIRECTIVES } from './shared.module';
/**
 * @hidden
 */
export var DIALOG_DIRECTIVES = [
    DialogComponent,
    DialogTitleBarComponent
];
/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Dialog component that includes all Dialog components and directives.
 *
 * Imports `DialogModule` into the [root module](https://angular.io/docs/ts/latest/guide/ngmodule.html#!#angular-modularity)
 * of your application or into any other sub-module that will use the Dialog component.
 *
 * @example
 * ```ts-no-run
 * import { NgModule } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 * import { DialogModule } from '@progress/kendo-angular-dialog';
 * import { AppComponent } from './app.component';
 *
 * _@NgModule({
 *     bootstrap:    [AppComponent],
 *     declarations: [AppComponent],
 *     imports:      [BrowserModule, DialogModule]
 * })
 * export class AppModule {
 * }
 * ```
 */
var DialogModule = /** @class */ (function () {
    function DialogModule() {
    }
    DialogModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DIALOG_DIRECTIVES, DialogContainerDirective],
                    entryComponents: [DIALOG_DIRECTIVES],
                    exports: [DIALOG_DIRECTIVES, SHARED_DIRECTIVES, DialogContainerDirective],
                    imports: [SharedModule],
                    providers: [DialogContainerService, DialogService]
                },] },
    ];
    /** @nocollapse */
    DialogModule.ctorParameters = function () { return []; };
    return DialogModule;
}());
export { DialogModule };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dialog/dist/es/dialog.module.js
// module id = ../../../../@progress/kendo-angular-dialog/dist/es/dialog.module.js
// module chunks = vendor